import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface DeleteMessageParams {
  threadId: string;
  messageId: string;
}

export const useDeleteMessageMutation = () => {
  return useMutation({
    mutationFn: ({ threadId, messageId }: DeleteMessageParams) =>
      fetchClient.DELETE(endpoints.threadMessage, {
        params: {
          path: {
            threadId,
            id: messageId,
          },
        },
      }),
    onSettled: (_data, _error, variables) => {
      const { threadId } = variables;

      invalidateQuery(messagingQueryKeys.threads())();
      invalidateQuery(messagingQueryKeys.thread(threadId))();
    },
  });
};
